// @ts-nocheck
import React from 'react';
import { ArrowUpRight } from 'lucide-react';

import { NamedLink } from '../../../components';

interface HeroSectionProps {
  sectionId: string;
  sectionData?: any[];
  [key: string]: any;
}

const HeroSection: React.FC<HeroSectionProps> = ({ sectionId, sectionData, ...extraProps }) => {
  return (
    <section className="relative overflow-hidden pt-16 sm:pt-20 lg:pt-28 pb-16 lg:pb-24">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('/hero-bg.jpg')" }}
      />
      <div className="absolute inset-0 bg-white/85 dark:bg-gray-950/90" />
      <div className="container px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center max-w-6xl mx-auto">
          <div className="space-y-6">
            <p className="font-bold text-destructive text-sm tracking-wide uppercase" data-testid="text-tagline">The cunning way to organize the chaos</p>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-extrabold tracking-tight leading-tight">
              Plan Kids' Activities{" "}
              <span className="text-primary">the Smart Way</span>{" "}
            </h1>
            <p className="text-lg text-muted-foreground font-medium max-w-lg">
              Find activities that match YOUR family's schedule.
            </p>
            <div className="flex flex-wrap items-center gap-4 pt-2">
              <NamedLink name="SearchPage">
                <span className="servibe-btn servibe-btn-primary inline-flex items-center gap-2 px-8 py-3.5 text-base" data-testid="button-find-activities">
                  <span>Explore Activities Now</span>
                  <ArrowUpRight className="h-5 w-5" />
                </span>
              </NamedLink>
              <a
                href="#kamp-planner"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById("kamp-planner")?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                <span className="servibe-btn servibe-btn-secondary inline-flex items-center gap-2 px-8 py-3.5 text-base" data-testid="button-plan-summer">
                  <span>CampScout - plan your camps the smart way</span>
                </span>
              </a>
              <NamedLink name="NewListingPage">
                <span className="inline-flex items-center gap-2 text-sm font-semibold text-[#E8681A] hover:underline underline-offset-4 transition-all cursor-pointer" data-testid="link-for-providers">
                  Are you a provider? <ArrowUpRight className="h-4 w-4" />
                </span>
              </NamedLink>
            </div>
          </div>

          <div className="relative hidden lg:flex items-center justify-center">
            <img
              src="/hero-calendar.png"
              alt="Weekly activity schedule showing Swim Class, Soccer Camp, Art Workshop and Movie Night"
              className="w-full max-w-lg rounded-2xl box-shadow-float"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
